import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useTotalSiteCount = () => {
  const { totalSiteCount } = useSnapshot(skipTracingStore);

  return totalSiteCount;
};
